.container {
    padding-inline: 24px;
    padding-block: 16px;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}